import AllhomesGlobalContext, { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import AllhomesApiProvider, { withAllhomesApiProvider } from './allhomes-api-provider';
import { allhomesApiFilteredProps } from './context-factory';
import { AuthenticationState } from './authentication';
import locality from './locality';
var AllhomesApi = AllhomesGlobalContext;
export default AllhomesApi;
export { AllhomesApiProvider, withAllhomesContext as withAllhomesApi, withAllhomesApiProvider, allhomesApiFilteredProps, AuthenticationState, locality as localityApi };